export function launchOtherSystemRequest(requestFactory, {signal, isActive, onSuccess, onError, onFinally}) {
    return Promise.resolve()
        .then(() => {
            if (signal.aborted || !isActive()) return undefined;
            return requestFactory({signal});
        })
        .then((result) => {
            if (!signal.aborted && isActive() && result !== undefined) onSuccess(result);
        })
        .catch((error) => {
            if (!signal.aborted && isActive()) onError(error);
        })
        .finally(() => {
            if (!signal.aborted && isActive()) onFinally();
        });
}
export function otherSystemDataViewState({loading, error, data}) {
    if (loading) return 'pending';
    if (error) return 'error';
    if (data === null || data === undefined) return 'error';
    return data.length === 0 ? 'empty' : 'populated';
}

